export const MIGRATION_DEFAULT_BATCH_SIZE = 200;
